import { useState, useEffect, useRef } from 'react'

/**
 * useful for triggering a change when an the dependacy may change frequently
 * created to help with triggering GA events on the error object from the form,
 * as the submit validation is behind form components
 *
 * @param cb memoised call back
 * @param guard used in addition to the change id
 */
export const useEffectAfterChange = (
  cb: () => void,
  guard = true
): (() => void) => {
  const [changeId, setChangeId] = useState(Symbol())
  const prevChangeId = useRef(changeId)
  useEffect(() => {
    if (changeId !== prevChangeId.current && guard) {
      prevChangeId.current = changeId
      cb()
    }
  }, [changeId, guard, cb])

  const changeChangeId = (): void => {
    setChangeId(Symbol())
  }
  return changeChangeId
}
